module.exports = __webpack_public_path__ + "static/images/b1399d720d311ef951b8f5b6c7c63d3f.webp";